import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import withTheme from "@material-ui/core/styles/withTheme";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  background-color: white;
  padding: 40px;
  height: 100%;
`;

const HelloText = styled.p`
  font-size: 48px;
  font-weight: 300;
  color: ${({ color }) => color};
  line-height: normal;
  @media (max-width: 1440px) {
    font-size: 42px;
  }
`;

// const SupportText = styled.p`
//   font-size: 24px;
//   color: rgba(0, 0, 0, 0.5);
//   line-height: 1.46;
//   @media (max-width: 1440px) {
//     font-size: 18px;
//   }
// `;

// const HighlightText = styled.span`
//   color: ${({ color }) => color};
// `;

const BannerImage = styled.img`
  min-height: 100%;
  max-width: 100%;
`;

const ContainerImg = styled(Grid)`
  text-align: right;
`;

const Banner = ({ theme, userName }) => {
  const { t } = useTranslation();
  const [imgFailed, setImgFailed] = useState(false);
  const homeAsset = theme && theme.assets ? theme.assets.home : null;
  const showImage = Boolean(homeAsset) && !imgFailed;

  return (
    <Container>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={showImage ? 7 : 12}>
          <HelloText color={theme.palette.primary.main}>
            {t("home.greeting")}
            <br />
            <strong>
              {userName}
              .
            </strong>
          </HelloText>
        </Grid>
        {showImage && (
          <ContainerImg item xs={5}>
            <BannerImage
              src={homeAsset}
              alt={t("home.bannerAlt")}
              onError={() => setImgFailed(true)}
            />
          </ContainerImg>
        )}
      </Grid>
    </Container>
  );
};

Banner.propTypes = {
  userName: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  theme: PropTypes.object.isRequired // Inject by withTheme
};

export default withTheme(Banner);
